/**
 * Helper function that converts pinLevel as number to text.
 */
export default function getPinLevel(pin) {
  switch (pin) {
    case 1:
      return "Associate IBO";
    case 2:
      return "Platinum";
    case 3:
      return "Emerald";
    case 4:
      return "Diamond";
    default:
      return "";
  }
}

export const getOriginalPinLevel = (pin) => getPinLevel(pin);
export const getNewPinLevel = (pin) => getPinLevel(pin);
